import { Domain } from 'auth-common/domain';
import dayjs from 'dayjs';
import type { components } from '../../generated/apiClient';
import type { AuthInfo } from '../../hook/model/authInfo';

const activeAccountGrantFromApi = (grant: components['schemas']['AuthInfo.ActiveAccountGrant']): AuthInfo.ActiveAccountGrant => ({
  id: Domain.Object.Account.Grant.Id.FromString(grant.id),
  expiresAt: dayjs(grant.expiresAt),
  ...(grant.reason === undefined ? {} : { reason: grant.reason }),
});

export const fromApi = (api: components['schemas']['AuthInfo.Account']): AuthInfo.Account => {
  return {
    id: Domain.Object.Account.Id.FromString(api.id),
    name: api.name,
    email: api.email,
    profileImageSrc: api.profileImageSrc,
    isSystemAdmin: api.hasActiveSystemAdmin,
    isEmployee: api.isEmployee,
    isSystemAdminEligible: api.isSystemAdminEligible,
    ...(api.activeSystemAdminGrant ? { activeSystemAdminGrant: activeAccountGrantFromApi(api.activeSystemAdminGrant) } : {}),
    hasActiveSystemAdmin: api.hasActiveSystemAdmin,
    isPiiEligible: api.isPiiEligible,
    ...(api.activePiiAccessGrant ? { activePiiAccessGrant: activeAccountGrantFromApi(api.activePiiAccessGrant) } : {}),
    hasActivePiiAccess: api.hasActivePiiAccess,
    isActive: api.isActive,
  };
};
